import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './FadeModalDialog.css';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '450px',
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  marginTop: '24px',
};

const ProOnboardModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate('/realtor-landing');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="pro-onboard-modal-title"
      aria-describedby="pro-onboard-modal-description"
      className="fade-modal"
    >
      <Box sx={modalStyle}>
        <Typography id="pro-onboard-modal-title" variant="h5" component="h2" gutterBottom>
          Professional Feature
        </Typography>
        <Typography id="pro-onboard-modal-description" sx={{ mt: 2, mb: 3 }}>
          This feature is for professionals. Are you sure you want to proceed?
        </Typography>
        <Typography sx={{ fontSize: '0.9rem', fontStyle: 'italic', color: 'text.secondary', mb: 2 }}>
          Note: You need to onboard as a professional to get FirstLand Plus.
        </Typography>
        
        <Box sx={buttonContainerStyle}>
          <Button 
            variant="outlined" 
            onClick={onClose}
            sx={{ 
              borderColor: '#64748B', 
              color: '#64748B',
              '&:hover': { 
                borderColor: '#475569',
                backgroundColor: 'rgba(100, 116, 139, 0.04)'
              }
            }}
          >
            No, Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleProceed}
            sx={{ 
              backgroundColor: '#3d689c', 
              '&:hover': { backgroundColor: '#2c4e76' }
            }}
          >
            Yes, Proceed
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProOnboardModal;
